var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper",
      class: { "design-time-bottom-margin": !!this.designer },
    },
    [
      !!_vm.field.formItemFlag &&
      (!_vm.field.options.hidden || _vm.designState === true)
        ? _c(
            "el-form-item",
            {
              class: [
                _vm.selected ? "selected" : "",
                _vm.labelAlign,
                _vm.customClass,
                _vm.field.options.required ? "required" : "",
              ],
              attrs: {
                label: _vm.label + "：",
                "label-width": _vm.labelWidth + "px",
                title: _vm.field.options.labelTooltip,
                rules: _vm.rules,
                prop: _vm.getPropName(),
              },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.selectField(_vm.field)
                },
              },
            },
            [
              !!_vm.field.options.labelIconClass
                ? _c(
                    "span",
                    {
                      staticClass: "custom-label",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _vm.field.options.labelIconPosition === "front"
                        ? [
                            !!_vm.field.options.labelTooltip
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.field.options.labelTooltip,
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: _vm.field.options.labelIconClass,
                                      }),
                                    ]
                                  ),
                                  _vm._v(_vm._s(_vm.label)),
                                ]
                              : [
                                  _c("i", {
                                    class: _vm.field.options.labelIconClass,
                                  }),
                                  _vm._v(_vm._s(_vm.label)),
                                ],
                          ]
                        : _vm.field.options.labelIconPosition === "rear"
                        ? [
                            !!_vm.field.options.labelTooltip
                              ? [
                                  _vm._v("\n          " + _vm._s(_vm.label)),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.field.options.labelTooltip,
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: _vm.field.options.labelIconClass,
                                      }),
                                    ]
                                  ),
                                ]
                              : [
                                  _vm._v(" " + _vm._s(_vm.label)),
                                  _c("i", {
                                    class: _vm.field.options.labelIconClass,
                                  }),
                                ],
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !!this.designer
        ? [
            _vm.designer.selectedId === _vm.field.id
              ? _c("div", { staticClass: "field-action" }, [
                  _c("i", {
                    staticClass: "el-icon-back",
                    attrs: {
                      title: _vm.i18nt("designer.hint.selectParentWidget"),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectParentWidget(_vm.field)
                      },
                    },
                  }),
                  _vm._v(" "),
                  !!_vm.parentList && _vm.parentList.length > 1
                    ? _c("i", {
                        staticClass: "el-icon-top",
                        attrs: {
                          title: _vm.i18nt("designer.hint.moveUpWidget"),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.moveUpWidget(_vm.field)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.parentList && _vm.parentList.length > 1
                    ? _c("i", {
                        staticClass: "el-icon-bottom",
                        attrs: {
                          title: _vm.i18nt("designer.hint.moveDownWidget"),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.moveDownWidget(_vm.field)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-delete",
                    attrs: { title: _vm.i18nt("designer.hint.remove") },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.removeFieldWidget($event)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.designer.selectedId === _vm.field.id
              ? _c("div", { staticClass: "drag-handler background-opacity" }, [
                  _c("i", {
                    staticClass: "el-icon-rank",
                    attrs: { title: _vm.i18nt("designer.hint.dragHandler") },
                  }),
                  _vm._v(" "),
                  _c("i", [
                    _vm._v(
                      _vm._s(
                        _vm.i18n2t(
                          "designer.widgetLabel." + _vm.field.type,
                          "extension.widgetLabel." + _vm.field.type
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.field.options.hidden === true
                    ? _c("i", { staticClass: "iconfont icon-hide" })
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }